<div class="documentation-table content">
  <div class="card">
    <div class="documentation-table_title">{{'CORE_TABLES' | translate}}</div>
  </div>

  <div class="card">
    <div class="row mb-3">
      <div class="col-12 mb-5">
        <div class="bold mb-2">LIST</div>
        <div class="list-responsive container-fluid">
          <div class="list-header row">
            <div class="col">{{'Nombre' | translate}}</div>
            <div class="col">{{'Id' | translate}}</div>
            <div class="documentation-table_list_actions">{{'CORE_ACTIONS' | translate}}</div>
          </div>
          <div class="list-row row" *ngFor="let item of listItems; let i = index">
            <div class="col">
              <div>
                <si-label text="Nombre" *ngIf="isMobileWidth"></si-label>
                <div>{{item.name}}</div>
              </div>
            </div>
            <div class="col">
              <div>
                <si-label text="Id" *ngIf="isMobileWidth"></si-label>
                <div>{{item.id}}</div>
              </div>
            </div>
            <div class="list-row_actions documentation-table_list_actions">
              <si-go-to-route-icon [href]="['/']"
                                   icon="icon-home font-color-main1"
                                   tooltip="SI_HOME"
              ></si-go-to-route-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-5">
        <div class="bold mb-2">LIST DYNAMIC</div>
        <div class="row mb-2">
          <div class="col-12 col-sm-6 col-md-3">
            <si-selector id="listDynamicSelectorFilter"
                         name="listDynamicSelectorFilter"
                         text="Añadir item"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="listDynamicSelectorFilterModel"
                         (modelChange)="onSelectListDynamicItem()"
                         path="https://jsonplaceholder.typicode.com/users"
            ></si-selector>
          </div>
        </div>
        <div>
          <si-list-dynamic #listDynamicExample [(items)]="listDynamicItems" [(itemAuxId)]="auxId" [addButton]="true">
            <div class="list-responsive container-fluid">
              <div class="list-header row">
                <div class="col">{{'Nombre' | translate}}</div>
                <div class="col">{{'Tipo' | translate}}</div>
                <div class="col">{{'Descripción' | translate}}</div>
                <div class="documentation-table_list-dynamic_actions">{{'CORE_ACTIONS' | translate}}</div>
              </div>
              <div class="list-row-dynamic row" *ngFor="let item of listDynamicExample.items; let i = index">
                <div class="col">
                  <si-input id="listDynamicInput{{item.auxId}}"
                            name="listDynamicInput{{item.auxId}}"
                            text="Nombre"
                            placeholder="SI_WRITE_HERE"
                            [(model)]="item.name"
                            [hideLabel]="!isMobileWidth"
                  ></si-input>
                </div>
                <div class="col">
                  <si-selector id="listDynamicSelector{{item.auxId}}"
                               name="listDynamicSelector{{item.auxId}}"
                               text="Tipo"
                               placeholder="SI_SELECT_PLACEHOLDER"
                               [(model)]="item.other"
                               path="https://jsonplaceholder.typicode.com/users"
                               [hideLabel]="!isMobileWidth"
                  ></si-selector>
                </div>
                <div class="col">
                  <si-multiline id="listDynamicMultiline{{item.auxId}}"
                                name="listDynamicMultiline{{item.auxId}}"
                                text="Descripción"
                                placeholder="SI_WRITE_HERE"
                                [(model)]="item.text"
                                [hideLabel]="!isMobileWidth"
                                [rows]="3"
                  ></si-multiline>
                </div>
                <div class="documentation-table_list-dynamic_actions">
                  <div class="list-row_actions">
                    <i class="icon-bin"></i>
                    <!--<si-delete-icon tooltip="SI_DELETE"-->
                    <!--titleDialog="Title"-->
                    <!--(updateChange)="listDynamicExample.onClickDeleteRow(i)"-->
                    <!--&gt;</si-delete-icon>-->
                  </div>
                </div>
              </div>
            </div>
          </si-list-dynamic>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="row">
      <div class="col-12 mb-5">
        <div class="bold mb-2">TABLE CON VALUE (CON SELECCIÓN ÚNICA)</div>
        <div>
          <si-table id="tableExample"
                    [value]="tableItems"
                    [lazy]="false">
            <p-table #pTable
                     dataKey="id"
                     [rows]="4"
                     selectionMode="single"
                     [(selection)]="tableValueSelectedItem"
                     [rowsPerPageOptions]="[1,2,4]"
                     (onRowSelect)="onRowSelectValue($event)">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="name" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-sortIcon field="name"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="surname" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Apellido' | translate}}" tooltipPosition="top" translate="Apellido"></span>
                      <p-sortIcon field="surname"></p-sortIcon>
                    </div>
                  </th>
                  <th>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Fecha de nacimiento' | translate}}"
                            tooltipPosition="top"
                            translate="Fecha de nacimiento">
                      </span>
                    </div>
                  </th>
                  <th>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'DNI' | translate}}" tooltipPosition="top" translate="DNI"></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item class="p-resizable-column">
                <tr [pSelectableRow]="item" class="si-table_row_hover"
                    [class.si-table_row-highlighted]="item.highlight">
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.name}}" tooltipPosition="top">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.surname}}" tooltipPosition="top">{{item.surname}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.birthDate | amDateFormat: 'L'}}" tooltipPosition="top">
                        {{item.birthDate | amDateFormat: 'L'}}
                      </span>
                    </div>
                  </td>
                  <td class="si-table_td-overflow">
                    <div class="d-flex">
                      <span pTooltip="{{item.documentId}}" tooltipPosition="top">{{item.documentId}}</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TABLE CON PATH (SIN SELECCIÓN)</div>
          <div class="ml-auto">
            <button siPreventDoubleClick
                    class="si-button"
                    (click)="applyFilters()">
              {{'SI_FILTER' | translate}}
            </button>
          </div>
        </div>
        <div>
          <si-table id="tablePathExample"
                    [reset]="resetTable"
                    [reload]="reloadTable"
                    path="https://jsonplaceholder.typicode.com/users">
            <p-table #pTable
                     dataKey="id">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="name" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-sortIcon field="name"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Usuario' | translate}}" tooltipPosition="top" translate="Usuario"></span>
                      <p-sortIcon field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="email" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Email' | translate}}" tooltipPosition="top" translate="Email"></span>
                      <p-sortIcon field="email"></p-sortIcon>
                    </div>
                  </th>
                  <th class="documentation-table_table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" class="p-resizable-column" let-item>
                <tr>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.name}}" tooltipPosition="top">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.username}}" tooltipPosition="top">{{item.username}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.email}}" tooltipPosition="top">{{item.email}}</span>
                    </div>
                  </td>
                  <td class="si-table_row_actions documentation-table_table_actions">
                    <div class="si-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TABLE CON PATH (CON COLUMNAS DINÁMICAS, DETALLE DE FILA, SELECCIÓN MÚLTIPLE Y STORAGE AUTOMÁTICO)</div>
          <div class="ml-auto d-flex">
            <button class="si-button mr-2">Imprimir</button>
            <div siStorage
                 siStorageName="tableSelectedColumns"
                 [siStorageLocal]="true"
                 [(siStorageModel)]="selectedColumns"
                 (siStorageModelChange)="onChangeSelectedColumns($event)">
              <si-selector-multiple id="dynamicColumnsSelectorExample"
                                    name="dynamicColumnsSelectorExample"
                                    placeholder="CORE_SHOW_COLUMNS"
                                    [(model)]="selectedColumns"
                                    (modelChange)="onChangeSelectedColumns($event)"
                                    [values]="dynamicCols"
                                    [compact]="true"
              ></si-selector-multiple>
            </div>
          </div>
        </div>
        <div>
          <si-table id="tablePathColumnsExample"
                    [reset]="resetTable"
                    [reload]="reloadTable"
                    path="https://jsonplaceholder.typicode.com/users">
            <p-table #pTable
                     dataKey="id"
                     [columns]="selectedColumns"
                     selectionMode="multiple"
                     [(selection)]="tablePathSelectedItems"
                     (onRowSelect)="onRowSelect($event)"
                     (onRowUnselect)="onRowUnselect($event)">
              <ng-template pTemplate="header" let-columns>
                <tr class="si-table_header_checkbox">
                  <th class="si-table_row_toggler-header"></th>
                  <th class="si-table-row-check_header">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th pSortableColumn="name" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-sortIcon field="name"></p-sortIcon>
                    </div>
                  </th>
                  <th pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Ciudad' | translate}}" tooltipPosition="top" translate="Ciudad"></span>
                    </div>
                  </th>
                  <ng-container *ngFor="let col of columns">
                    <th *ngIf="!col.sortable; else sortableHeader"
                        pResizableColumn
                        [style.width]="col.width">
                      <div class="si-table_header_cell">
                        <span pTooltip="{{col.name | translate}}"
                              tooltipPosition="top"
                              translate="{{col.name | translate}}">
                        </span>
                      </div>
                    </th>
                    <ng-template #sortableHeader>
                      <th pResizableColumn
                          pSortableColumn="{{col.field}}"
                          [style.width]="col.width">
                        <div class="si-table_header_cell">
                          <span pTooltip="{{col.name | translate}}"
                                tooltipPosition="top"
                                translate="{{col.name | translate}}">
                          </span>
                          <p-sortIcon field="{{col.field}}"></p-sortIcon>
                        </div>
                      </th>
                    </ng-template>
                  </ng-container>
                  <th class="documentation-table_table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body"
                           class="p-resizable-column"
                           let-item
                           let-rowIndex="rowIndex"
                           let-columns="columns"
                           let-expanded="expanded">
                <tr [class.si-table_row_expanded]="expanded">
                  <td class="si-table_row_toggler"
                      [pRowToggler]="item"
                      [class.disabled]="!nonSelectedColumns?.length"
                      siClickStopPropagation>
                    <i [ngClass]="expanded ? 'icon-up' : 'icon-down'"></i>
                  </td>
                  <td class="si-table_td_checkbox">
                    <p-tableCheckbox [value]="item"
                                     [index]="rowIndex"
                    ></p-tableCheckbox>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.name}}" tooltipPosition="top">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.address?.city}}" tooltipPosition="top">{{item.address?.city}}</span>
                    </div>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                      <td *ngSwitchCase="'username'">
                        <div class="d-flex justify-content-center">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">
                            {{item[col.field] | uppercase}}
                          </span>
                        </div>
                      </td>
                      <td *ngSwitchDefault>
                        <div class="d-flex">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">{{item[col.field]}}</span>
                        </div>
                      </td>
                    </ng-container>
                  </ng-container>
                  <td class="si-table_row_actions documentation-table_table_actions">
                    <div class="si-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="rowexpansion" let-item>
                <tr class="si-table_row_expansion">
                  <td [attr.colspan]="selectedColumns.length + 5">
                    <div class="row">
                      <div class="col-4 d-flex si-table_row_expansion_block" *ngFor="let col of nonSelectedColumns">
                        <div>
                          <div class="si-table_row_expansion_block_title">
                            <span>{{col.name | translate}}:</span>
                          </div>
                        </div>
                        <div>
                          <ng-container [ngSwitch]="col.field">
                            <span *ngSwitchCase="'username'">{{(item[col.field] | uppercase) || '-'}}</span>
                            <span *ngSwitchDefault>{{ item[col.field] || '-'}}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TABLE CON PATH (CON PARTE CONGELADA, PARTE MÓVIL Y STORAGE MANUAL)</div>
          <div class="ml-auto d-flex">
            <button class="si-button_secondary mr-2" (click)="setStorageSelectedColumns2()">SET STORAGE</button>
            <div siStorage
                 siStorageName="tableSelectedColumns2"
                 [siStorageLocal]="true"
                 [siStorageManualSet]="siStorageManualSet"
                 [(siStorageModel)]="selectedColumns2"
                 (siStorageModelChange)="onChangeSelectedColumns2($event)">
              <si-selector-multiple id="dynamicColumnsSelectorExample2"
                                    name="dynamicColumnsSelectorExample2"
                                    placeholder="CORE_SHOW_COLUMNS"
                                    [(model)]="selectedColumns2"
                                    (modelChange)="onChangeSelectedColumns2($event)"
                                    [values]="dynamicCols"
                                    [compact]="true"
              ></si-selector-multiple>
            </div>
          </div>
        </div>
        <div *ngIf="isDesktop">
          <si-table id="tablePathFrozenExample"
                    [reset]="resetTable"
                    [reload]="reloadTable"
                    [frozen]="true"
                    path="https://jsonplaceholder.typicode.com/users">
            <p-table #pTable
                     dataKey="id"
                     frozenWidth="1000px"
                     [columns]="selectedColumns2">
              <ng-template pTemplate="frozencolgroup">
                <colgroup>
                  <col>
                  <col>
                </colgroup>
              </ng-template>
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <col [style.min-width]="'600px'">
                  <col *ngFor="let col of columns" [style.min-width]="col.width || '400px'">
                  <col class="documentation-table_table_actions">
                </colgroup>
              </ng-template>
              <ng-template pTemplate="frozenheader">
                <tr>
                  <th pSortableColumn="name" pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-sortIcon field="name"></p-sortIcon>
                    </div>
                  </th>
                  <th pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Ciudad' | translate}}" tooltipPosition="top" translate="Ciudad"></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Ciudad2' | translate}}" tooltipPosition="top" translate="Ciudad2"></span>
                    </div>
                  </th>
                  <ng-container *ngFor="let col of columns">
                    <th *ngIf="!col.sortable; else sortableHeader"
                        pResizableColumn
                        [style.min-width]="col.width || '400px'">
                      <div class="si-table_header_cell">
                        <span pTooltip="{{col.name | translate}}"
                              tooltipPosition="top"
                              translate="{{col.name | translate}}">
                        </span>
                      </div>
                    </th>
                    <ng-template #sortableHeader>
                      <th pResizableColumn
                          pSortableColumn="{{col.field}}"
                          [style.min-width]="col.width || '400px'">
                        <div class="si-table_header_cell">
                          <span pTooltip="{{col.name | translate}}"
                                tooltipPosition="top"
                                translate="{{col.name | translate}}">
                          </span>
                          <p-sortIcon field="{{col.field}}"></p-sortIcon>
                        </div>
                      </th>
                    </ng-template>
                  </ng-container>
                  <th class="documentation-table_table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="frozenbody" let-item>
                <tr>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.name}}" tooltipPosition="top">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.address?.city}}" tooltipPosition="top">{{item.address?.city}}</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="body"
                           class="p-resizable-column"
                           let-item
                           let-columns="columns">
                <tr>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.address?.city}}" tooltipPosition="top">{{item.address?.city}}</span>
                    </div>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                      <td *ngSwitchCase="'username'">
                        <div class="d-flex justify-content-center">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">
                            {{item[col.field] | uppercase}}
                          </span>
                        </div>
                      </td>
                      <td *ngSwitchDefault>
                        <div class="d-flex">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">{{item[col.field]}}</span>
                        </div>
                      </td>
                    </ng-container>
                  </ng-container>
                  <td class="si-table_row_actions documentation-table_table_actions">
                    <div class="si-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TABLE CON PATH (CON SCROLL HORIZONTAL)</div>
          <div class="ml-auto d-flex">
            <div siStorage
                 siStorageName="tableSelectedColumns3"
                 [siStorageLocal]="true"
                 [(siStorageModel)]="selectedColumns3"
                 (siStorageModelChange)="onChangeSelectedColumns($event)">
              <si-selector-multiple id="dynamicColumnsSelectorExample3"
                                    name="dynamicColumnsSelectorExample3"
                                    placeholder="CORE_SHOW_COLUMNS"
                                    [(model)]="selectedColumns3"
                                    (modelChange)="onChangeSelectedColumns($event)"
                                    [values]="dynamicCols"
                                    [compact]="true"
              ></si-selector-multiple>
            </div>
          </div>
        </div>
        <div class="si-table-scrollable-page">
          <si-table id="tablePathHorizontalScrollExample"
                    [reset]="resetTable"
                    [reload]="reloadTable"
                    path="https://jsonplaceholder.typicode.com/users">
            <p-table #pTable
                     dataKey="id"
                     styleClass="si-table-scrollable-page_horizontal-table"
                     [scrollable]="true"
                     [columns]="selectedColumns3">
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <col [style.min-width]="'600px'">
                  <col *ngFor="let col of columns" [style.min-width]="col.width || '400px'">
                  <col class="documentation-table_table_actions">
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pResizableColumn>
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'Ciudad2' | translate}}" tooltipPosition="top" translate="Ciudad2"></span>
                    </div>
                  </th>
                  <ng-container *ngFor="let col of columns">
                    <th *ngIf="!col.sortable; else sortableHeader"
                        pResizableColumn
                        [style.min-width]="col.width || '400px'">
                      <div class="si-table_header_cell">
                        <span pTooltip="{{col.name | translate}}"
                              tooltipPosition="top"
                              translate="{{col.name | translate}}">
                        </span>
                      </div>
                    </th>
                    <ng-template #sortableHeader>
                      <th pResizableColumn
                          pSortableColumn="{{col.field}}"
                          [style.min-width]="col.width || '400px'">
                        <div class="si-table_header_cell">
                          <span pTooltip="{{col.name | translate}}"
                                tooltipPosition="top"
                                translate="{{col.name | translate}}">
                          </span>
                          <p-sortIcon field="{{col.field}}"></p-sortIcon>
                        </div>
                      </th>
                    </ng-template>
                  </ng-container>
                  <th class="documentation-table_table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body"
                           class="p-resizable-column"
                           let-item
                           let-columns="columns">
                <tr>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{item.address?.city}}" tooltipPosition="top">{{item.address?.city}}</span>
                    </div>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                      <td *ngSwitchCase="'username'">
                        <div class="d-flex justify-content-center">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">
                            {{item[col.field] | uppercase}}
                          </span>
                        </div>
                      </td>
                      <td *ngSwitchDefault>
                        <div class="d-flex">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">{{item[col.field]}}</span>
                        </div>
                      </td>
                    </ng-container>
                  </ng-container>
                  <td class="si-table_row_actions documentation-table_table_actions">
                    <div class="si-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TABLE CON PATH (CON FILAS Y COLUMNAS REORDENABLES CON DRAG & DROP)</div>
        </div>
        <div>
          <si-table id="tablePathReorderExample"
                    [reset]="resetTable"
                    [reload]="reloadTable"
                    path="https://jsonplaceholder.typicode.com/users">
            <p-table #pTable
                     dataKey="id"
                     [columns]="tablePathDragDropCols"
                     [reorderableColumns]="true">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th class="si-table_header_dragable"></th>
                  <ng-container *ngFor="let col of columns">
                    <th *ngIf="!col.sortable; else sortableHeader"
                        pResizableColumn
                        pReorderableColumn
                        [style.width]="col.width">
                      <div class="si-table_header_cell">
                        <i class="icon-drag dragable mr-2" pReorderableRowHandle></i>
                        <span pTooltip="{{col.name | translate}}"
                              tooltipPosition="top"
                              translate="{{col.name | translate}}">
                        </span>
                      </div>
                    </th>
                    <ng-template #sortableHeader>
                      <th pResizableColumn
                          pReorderableColumn
                          pSortableColumn="{{col.field}}"
                          [style.width]="col.width">
                        <div class="si-table_header_cell">
                          <i class="icon-drag dragable mr-2" pReorderableRowHandle></i>
                          <span pTooltip="{{col.name | translate}}"
                                tooltipPosition="top"
                                translate="{{col.name | translate}}">
                          </span>
                          <p-sortIcon field="{{col.field}}"></p-sortIcon>
                        </div>
                      </th>
                    </ng-template>
                  </ng-container>
                  <th class="documentation-table_table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body"
                           class="p-resizable-column"
                           let-item
                           let-rowIndex="rowIndex"
                           let-columns="columns">
                <tr [pReorderableRow]="rowIndex">
                  <td>
                    <i class="icon-drag dragable" pReorderableRowHandle></i>
                  </td>
                  <ng-container *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                      <td *ngSwitchCase="'username'">
                        <div class="d-flex justify-content-center">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">
                            {{item[col.field] | uppercase}}
                          </span>
                        </div>
                      </td>
                      <td *ngSwitchDefault>
                        <div class="d-flex">
                          <span pTooltip="{{item[col.field]}}" tooltipPosition="top">{{item[col.field]}}</span>
                        </div>
                      </td>
                    </ng-container>
                  </ng-container>
                  <td class="si-table_row_actions documentation-table_table_actions">
                    <div class="si-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </si-table>
        </div>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="isDesktop">
    <div class="row">
      <div class="col-12 mb-5">
        <div class="bold mb-2 d-flex">
          <div>TREE TABLE CON VALUE (CON SELECCIÓN MÚLTIPLE)</div>
          <div class="ml-auto">
            <button siPreventDoubleClick class="si-button_secondary" (click)="onClickDisableTreeTableCheck()">
              HABILITAR/DESHABILITAR CHECKS
            </button>
          </div>
        </div>
        <div>
          <si-tree-table id="treeTableExample"
                         [lazy]="false"
                         [model]="treeTableItems"
                         valueAttrParent="groupId"
                         [disabledRowFunction]="isRowDisabled.bind(this)">
            <p-treeTable selectionMode="multiple"
                         [(selection)]="treeTableSelectedItems">
              <ng-template pTemplate="header">
                <tr>
                  <th class="si-tree-table-row-check_header">
                    <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                  </th>
                  <th ttSortableColumn="name" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-treeTableSortIcon field="name"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="insurance" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Garante' | translate}}" tooltipPosition="top" translate="Garante"></span>
                      <p-treeTableSortIcon field="insurance"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="collective" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Convenio' | translate}}" tooltipPosition="top" translate="Convenio"></span>
                      <p-treeTableSortIcon field="collective"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th class="documentation-table_tree-table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr>
                  <td>
                    <p-treeTableCheckbox [value]="rowNode"
                                         [disabled]="isRowDisabled(rowData)"
                    ></p-treeTableCheckbox>
                  </td>
                  <td>
                    <div class="d-flex align-items-center">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <span pTooltip="{{rowData.name}}" tooltipPosition="top">{{rowData.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.insurance}}" tooltipPosition="top">{{rowData.insurance}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.collective}}" tooltipPosition="top">{{rowData.collective}}</span>
                    </div>
                  </td>
                  <td class="si-tree-table_row_actions documentation-table_tree-table_actions">
                    <div class="si-tree-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-treeTable>
          </si-tree-table>
        </div>
      </div>

      <div class="col-12 mb-5" *ngIf="isDesktop">
        <div class="bold mb-2 d-flex">
          <div>TREE TABLE CON VALUE (DYNAMIC COMO LIST DYNAMIC)</div>
        </div>
        <div class="row mb-2">
          <div class="col-12 col-sm-6 col-md-3">
            <si-selector id="treeTableDynamicSelectorFilter"
                         name="treeTableDynamicSelectorFilter"
                         text="Añadir item"
                         placeholder="SI_SELECT_PLACEHOLDER"
                         [(model)]="treeTableDynamicSelectorFilterModel"
                         (modelChange)="onSelectTreeTableDynamicItem()"
                         path="https://jsonplaceholder.typicode.com/users"
            ></si-selector>
          </div>
        </div>
        <div>
          <si-tree-table #treeTableDynamicExample
                         id="treeTableDynamicExample"
                         [lazy]="false"
                         [(model)]="treeTableItems"
                         valueAttrParent="groupId">
            <p-treeTable [paginator]="false">
              <ng-template pTemplate="header">
                <tr>
                  <th ttSortableColumn="name" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-treeTableSortIcon field="name"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="insurance" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Garante' | translate}}" tooltipPosition="top" translate="Garante"></span>
                      <p-treeTableSortIcon field="insurance"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="collective" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Convenio' | translate}}" tooltipPosition="top" translate="Convenio"></span>
                      <p-treeTableSortIcon field="collective"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th class="documentation-table_tree-table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <span pTooltip="{{rowData.name}}" tooltipPosition="top">{{rowData.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.insurance}}" tooltipPosition="top">{{rowData.insurance}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.collective}}" tooltipPosition="top">{{rowData.collective}}</span>
                    </div>
                  </td>
                  <td class="si-tree-table_row_actions documentation-table_tree-table_actions">
                    <div class="si-tree-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-treeTable>
          </si-tree-table>
        </div>
      </div>

      <div class="col-12 mb-5" *ngIf="isDesktop">
        <div class="bold mb-2">TREE TABLE CON PATH</div>
        <div>
          <si-tree-table id="treeTablePathExample"
                         [reset]="resetTreeTable"
                         [reload]="reloadTreeTable"
                         path="https://jsonplaceholder.typicode.com/users"
                         filters="startDate=1613948400000">
            <p-treeTable>
              <ng-template pTemplate="header">
                <tr>
                  <th ttSortableColumn="name" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Nombre' | translate}}" tooltipPosition="top" translate="Nombre"></span>
                      <p-treeTableSortIcon field="name"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="insurance" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Usuario' | translate}}" tooltipPosition="top" translate="Usuario"></span>
                      <p-treeTableSortIcon field="insurance"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th ttSortableColumn="collective" ttResizableColumn>
                    <div class="si-tree-table_header_cell">
                      <span pTooltip="{{'Email' | translate}}" tooltipPosition="top" translate="Email"></span>
                      <p-treeTableSortIcon field="collective"></p-treeTableSortIcon>
                    </div>
                  </th>
                  <th class="documentation-table_tree-table_actions">
                    <div class="si-table_header_cell">
                      <span pTooltip="{{'CORE_ACTIONS' | translate}}"
                            tooltipPosition="top"
                            translate="CORE_ACTIONS"
                      ></span>
                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                      <span pTooltip="{{rowData.name}}" tooltipPosition="top">{{rowData.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.username}}" tooltipPosition="top">{{rowData.username}}</span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <span pTooltip="{{rowData.email}}" tooltipPosition="top">{{rowData.email}}</span>
                    </div>
                  </td>
                  <td class="si-tree-table_row_actions documentation-table_tree-table_actions">
                    <div class="si-tree-table_row_actions_container">
                      <si-go-to-route-icon [href]="['/']"
                                           icon="icon-home font-color-main1"
                                           tooltip="SI_HOME"
                      ></si-go-to-route-icon>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-treeTable>
          </si-tree-table>
        </div>
      </div>
    </div>
  </div>
</div>
